import React, { PropTypes } from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { DisplayTypes } from 'shared/constants/FlowConstants';

const DisplayTypeIcon = ({ displayType }) => {
  let iconName = 'table';
  if (displayType === DisplayTypes.schedule) {
    iconName = 'indent';
  } else if (displayType === DisplayTypes.list) {
    iconName = 'list';
  }
  return <Icon className="tab-shows-list-table-icons" name={iconName} />;
};

DisplayTypeIcon.propTypes = {
  displayType: PropTypes.string,
};

export default DisplayTypeIcon;
